import api from "../AllRisk/baseApi.js";

export default {
    async GetStates() {
        if (!sessionStorage.getItem("GetStates")) {
            var response = await api.get("IM/GetStates");
            sessionStorage.setItem("GetStates", JSON.stringify(response.data));
        }

        return JSON.parse(sessionStorage.getItem("GetStates"));
    },

    async GetCompanies() {
        if (!sessionStorage.getItem("GetCompanies")) {
            var response = await api.get("IM/GetCompanies");
            sessionStorage.setItem("GetCompanies", JSON.stringify(response.data));
        }

        return JSON.parse(sessionStorage.getItem("GetCompanies"));
    },

    async GetExternalCompanies() {
        if (!sessionStorage.getItem("GetExternalCompanies")) {
            var response = await api.get("IM/GetExternalCompanies");
            sessionStorage.setItem("GetExternalCompanies", JSON.stringify(response.data));
        }

        return JSON.parse(sessionStorage.getItem("GetExternalCompanies"));
    },

    GetADUserInformationByUsername(username) {
        return api.post("IM/GetADUserInformationByUsername", "\"" + username + "\"", { headers: { "Content-Type": "application/json" } });
    },

    async GetBU() {
        if (!sessionStorage.getItem("GetBU")) {
            var response = await api.get("IM/GetBU");
            sessionStorage.setItem("GetBU", JSON.stringify(response.data));
        }

        return JSON.parse(sessionStorage.getItem("GetBU"));
    },

    async GetBranches() {
        if (!sessionStorage.getItem("GetBranches")) {
            var response = await api.get("IM/GetBranches");
            sessionStorage.setItem("GetBranches", JSON.stringify(response.data));
        }

        return JSON.parse(sessionStorage.getItem("GetBranches"));
    },

    async GetDivisionWithDirector(id) {
        return await api.get("IM/GetDivisionWithDirector/" + id);
    },

    async GetLegalRepresentant(arg) {
        return await api.post("IM/GetLegalRepresentant", arg);
    },

    async GetBUDirectorByJobTitleId(buId,jobTitleId) {
        return await api.get("IM/GetBUDirectorByJobTitleId/" + buId + "/" + jobTitleId);
    }   
}